import React, { useEffect } from "react";
// import { Trello } from '../../../../@types/my-trello-types';
import { jsx, css } from "@emotion/react";
// import { formatDistanceToNow } from 'date-fns'
// import trelloColors from '../../../shared/styles/trello-colors';
import LinkLikeButton from "../../../shared/components/link-like-button";
// import Popover from '../../../modal/components/popover/popover';
import PopoverConfirmationContent from "../../../shared/components/popover-confirmation-content";
import { Trello } from "../../../../../external/trello-pu__core/trello-iframe/trello";
import Popover from "../../../shared/components/popover/popover";
import trelloColors from "../../../../styles/trello-colors";

type TProps = {
  attachment: Trello.Attachment;
  onRemoveAttachmentRequest(idAttachment: string): void;
};

//ToDo: Make sure that clicking two 'Remove' for different cards, shows only the latest one
function AttachedRemovedCard(props: TProps) {
  return (
    <div css={styles.container}>
      <span css={null}>{props.attachment.url}</span>
      <Popover
        trigger={(togglePopover) => (
          <LinkLikeButton onClick={togglePopover}>Remove</LinkLikeButton>
        )}
        title="Remove Attachment?"
        isEmbedded={true}
        render={() => (
          <PopoverConfirmationContent
            confirmationContent={`Remove this attachment? There is no undo`}
            confirmationContentCss={styles.confirmationContent}
            confirmationButtonText={"Remove"}
            confirmationButtonTrelloClass={"mod-danger"}
            onConfirmationButtonClick={() => {
              props.onRemoveAttachmentRequest(props.attachment.id);
              close();
            }}
          />
        )}
      />
    </div>
  );
}

export default AttachedRemovedCard;

const styles = {
  container: css`
    display: flex;
    justify-content: space-between;
    height: 20px;
  `,
  linkLike: css`
    text-decoration-line: underline;
    color: ${trelloColors.N300};
    cursor: pointer;
    &:hover {
      color: ${trelloColors.N800};
    }
  `,
  confirmationContent: css`
    text-align: start;
  `,
};
